export default __webpack_public_path__ + "static/media/6464Img.126ebd0b.svg";